import { api } from '../lib/axios';
import type {
  FlowRunNode,
  FlowRunStatus,
  FlowRunsPaginated,
} from '../types/flow-execution.types';

export interface ListFlowRunsParams {
  flowId: string;
  page?: number;
  limit?: number;
  status?: FlowRunStatus;
  flowVersionHistoryId?: string | null;
}

async function listFlowRuns({
  flowId,
  page,
  limit,
  status,
  flowVersionHistoryId,
}: ListFlowRunsParams): Promise<FlowRunsPaginated> {
  const params: Record<string, string | number> = {};
  if (page !== undefined) params.page = page;
  if (limit !== undefined) params.limit = limit;
  if (status) params.status = status;
  if (flowVersionHistoryId === null) {
    params.flowVersionHistoryId = 'null';
  } else if (flowVersionHistoryId) {
    params.flowVersionHistoryId = flowVersionHistoryId;
  }
  const response = await api.get<FlowRunsPaginated>(
    `/executions_logs/flows/${flowId}/runs`,
    { params },
  );
  return response.data;
}

async function listFlowRunNodes(
  flowId: string,
  execId: string,
): Promise<FlowRunNode[]> {
  const response = await api.get<FlowRunNode[]>(
    `/executions_logs/flows/${flowId}/runs/${execId}/nodes`,
  );
  return response.data;
}

export { listFlowRuns, listFlowRunNodes };
